'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var PeerQueue = require('../peer-list/peer-queue');

var utils = require('../utils'); // TODO: Temporary until parallel dial in Switch have a proper
// timeout. Requires async/await refactor of transports and
// dial abort logic. This gives us 30s to complete the `queryFunc`.
// This should help reduce the high end call times of queries


var QUERY_FUNC_TIMEOUT = 30e3;
/**
 * Manages a single Path through the DHT.
 */

var Path = /*#__PURE__*/function () {
  /**
   * Creates a Path.
   *
   * @param {Run} run
   * @param {queryFunc} queryFunc
   */
  function Path(run, queryFunc) {
    _classCallCheck(this, Path);

    this.run = run;
    this.queryFunc = utils.withTimeout(queryFunc, QUERY_FUNC_TIMEOUT);
    if (!this.queryFunc) throw new Error('Path requires a `queryFn` to be specified');
    if (typeof this.queryFunc !== 'function') throw new Error('Path expected `queryFn` to be a function. Got ' + typeof this.queryFunc);
    /**
     * @type {Array<PeerId>}
     */

    this.initialPeers = [];
    /**
     * @type {PeerQueue}
     */

    this.peersToQuery = null;
  }
  /**
   * Add a peer to the set of peers that are used to intialize the path.
   * @param {PeerId} peer
   */


  _createClass(Path, [{
    key: "addInitialPeer",
    value: function addInitialPeer(peer) {
      this.initialPeers.push(peer);
    }
    /**
     * Execute the path.
     *
     * @returns {Promise}
     *
     */

  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var queue;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return PeerQueue.fromKey(this.run.query.key);

              case 2:
                queue = _context.sent;
                // Add initial peers to the queue
                this.peersToQuery = queue;
                _context.next = 6;
                return Promise.all(this.initialPeers.map(function (peer) {
                  return _this.addPeerToQuery(peer);
                }));

              case 6:
                _context.next = 8;
                return this.run.workerQueue(this);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute() {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
    /**
     * Add a peer to the peers to be queried.
     *
     * @param {PeerId} peer
     * @returns {Promise<void>}
     */

  }, {
    key: "addPeerToQuery",
    value: function () {
      var _addPeerToQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peer) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.run.query.dht._isSelf(peer)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!this.run.peersSeen.has(peer.toB58String())) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return this.peersToQuery.enqueue(peer);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addPeerToQuery(_x) {
        return _addPeerToQuery.apply(this, arguments);
      }

      return addPeerToQuery;
    }()
  }]);

  return Path;
}();

module.exports = Path;